/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  ListVariantImagesQueryResponse,
  ListVariantImagesPathParams,
  ListVariantImages404,
} from '../types/ListVariantImages'

function getListVariantImagesUrl({
  variant_id,
}: {
  variant_id: ListVariantImagesPathParams['variant_id']
}) {
  const res = {
    method: 'GET',
    url: `/api/v1/products/catalog/variants/${variant_id}/images/` as const,
  }
  return res
}

/**
 * @description Get all images for a variant.
 * Args:
 * variant_id: ID of the variant
 * Returns:
 * Response with list of images including is_main flag
 * @summary List variant images
 * {@link /api/v1/products/catalog/variants/:variant_id/images/}
 */
export async function listVariantImages(
  { variant_id }: { variant_id: ListVariantImagesPathParams['variant_id'] },
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    ListVariantImagesQueryResponse,
    ResponseErrorConfig<ListVariantImages404>,
    unknown
  >({
    method: 'GET',
    url: getListVariantImagesUrl({ variant_id }).url.toString(),
    ...requestConfig,
  })
  return res.data
}
